export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5592.b26d5032.jpg";